<template>
  <div class="card not-word-wrap mb-3">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <form v-on:submit.prevent="">
        <div class="row" v-if="isManager">
          <div class="col-xxl-3 col-xl-4">
            <label for="branch-code">شعبه</label>
            <Vselect
              id="branch-code"
              v-model="branchCode"
              :reduce="(item) => item.brancheCode || item.branchCode"
              :get-option-label="formatBranchOptionLabel"
              label="brancheName"
              :options="branches"
            >
              <div slot="no-options">شعبه‌ای یافت نشد</div>
            </Vselect>
          </div>
        </div>
        <div class="row mt-3" v-if="isManager && branchCode">
          <div class="col-lg-2 col-md-3 col-6">
            <label class="rdiobox"
              ><input
                @change="changeOrderTarget"
                v-model="orderTarget"
                name="order-target"
                value="branch"
                type="radio"
              /><span>برای خود شعبه</span></label
            >
          </div>
          <div class="col-lg-2 col-md-3 col-6">
            <label class="rdiobox"
              ><input
                @change="changeOrderTarget"
                v-model="orderTarget"
                name="order-target"
                value="customer"
                type="radio"
              /><span>برای مشتری</span></label
            >
          </div>
        </div>
        <div class="row mt-3" v-if="requiresCustomer">
          <div class="col-lg-2 col-md-3 col-6">
            <label class="rdiobox"
              ><input
                @change="changeCustomerType"
                v-model="customerType"
                name="customer-type"
                value="1"
                checked
                type="radio"
              /><span>مشتری حقیقی</span></label
            >
          </div>
          <div class="col-lg-2 col-md-3 col-6">
            <label class="rdiobox"
              ><input
                @change="changeCustomerType"
                v-model="customerType"
                name="customer-type"
                value="2"
                type="radio"
              /><span>مشتری حقوقی</span></label
            >
          </div>
        </div>
        <div class="row mt-3" v-if="requiresCustomer">
          <div class="col-xxl-3 col-xl-4 ">
            <form v-on:submit.prevent="searchCustomer">
              <label for="national-code">
                {{ customerType == 1 ? "کد ملی" : "شناسه ملی" }}
              </label>
              <div class="input-group ">
                <input
                  class="form-control text-left"
                  :maxlength="maxLength"
                  id="national-code"
                  type="tel"
                  v-model="nationalCode"
                  @input="onIdentifierInput"
                />
                <span class="input-group-btn"
                  ><button
                    class="btn ripple btn-primary"
                    type="submit"
                    :disabled="
                      (customerType == 1 && nationalCode.length != 10) ||
                        (customerType == 2 && nationalCode.length != 11) ||
                        (isManager && !branchCode)
                    "
                  >
                    <span class="input-group-btn"
                      ><i class="fa fa-search"></i
                    ></span></button
                ></span>
              </div>
            </form>
          </div>
          <div class="col-12 mt-2" v-if="registerUser">
            <hr />
            <p style="color: red;">
              <label style="color: red; height: 2px;">*</label> وارد کردن شماره
              ملی، شماره همراه و تاریخ تولد برای <strong>شاهکار</strong> و
              <strong> ثبت احوال</strong> الزامی است.
            </p>
            <div class="col-8 m-auto">
              <div class="card p-4">
                <div class="row">
                  <div class="col-6" v-if="customerType == 2">
                    <div class="form-group">
                      <label
                        ><label style="color: red; height: 2px;">*</label> نام
                        فارسی شرکت</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="companyName"
                      />
                    </div>
                  </div>
                  <div class="col-6" v-if="customerType == 2">
                    <div class="form-group">
                      <label>شناسه ملی شرکت</label>
                      <input
                        type="tel"
                        class="form-control"
                        :value="nationalCode"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-6" v-if="customerType == 2">
                    <div class="form-group">
                      <label>شماره ثبت شرکت (اختیاری)</label>
                      <input
                        type="tel"
                        class="form-control"
                        v-model="registerNumber"
                      />
                    </div>
                  </div>
                  <div class="col-6" v-if="shahkarVerify && realInquiryVerify">
                    <div class="form-group">
                      <label>نام</label>
                      <p type="text" class="form-control">
                        {{ userFirstName }}
                      </p>
                    </div>
                  </div>
                  <div class="col-6" v-if="shahkarVerify && realInquiryVerify">
                    <div class="form-group">
                      <label>نام خانوادگی</label>
                      <p type="text" class="form-control">{{ userLastName }}</p>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        ><label style="color: red; height: 2px;">*</label> کد
                        ملی {{ customerType == 2 ? "نماینده" : "" }}</label
                      >
                      <input
                        type="tel"
                        class="form-control"
                        v-model="userNationalCode"
                        v-mask="'##########'"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        ><label style="color: red; height: 2px;">*</label> شماره
                        همراه</label
                      >
                      <input
                        type="tel"
                        class="form-control"
                        v-model="userPhone"
                        v-mask="'09##-#######'"
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        ><label style="color: red; height: 2px;">*</label> تاریخ
                        تولد</label
                      >
                      <Datepicker
                        locale="fa"
                        :auto-submit="true"
                        v-model="userBirthdate"
                        :locale-config="{
                          fa: {
                            displayFormat: 'jYYYY/jMM/jDD',
                            lang: { label: 'شمسی' },
                          },
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row"
                style="justify-content: center; margin-top: 1rem;"
              >
                <div
                  class="d-flex flex-column align-items-center"
                  style="width: 100%;"
                >
                  <!-- وضعیت استعلام‌ها -->
                  <div class="verification-status mb-3" v-if="triedVerify">
                    <div
                      class="status-item text-center"
                      :class="{
                        'text-success': shahkarVerify,
                        'text-danger': !shahkarVerify,
                      }"
                    >
                      <i
                        :class="
                          shahkarVerify
                            ? 'fa fa-check-circle'
                            : 'fa fa-times-circle'
                        "
                      ></i>
                      <span>استعلام شاهکار</span>
                    </div>
                    <div
                      class="status-item text-center mt-1"
                      :class="{
                        'text-success': realInquiryVerify,
                        'text-danger': !realInquiryVerify,
                      }"
                    >
                      <i
                        :class="
                          realInquiryVerify
                            ? 'fa fa-check-circle'
                            : 'fa fa-times-circle'
                        "
                      ></i>
                      <span>استعلام ثبت احوال</span>
                    </div>
                  </div>

                  <!-- دکمه‌ها -->
                  <div
                    style="width: 100%; max-width: 300px;"
                    v-if="!shahkarVerify || !realInquiryVerify"
                  >
                    <button
                      class="btn btn-warning w-full"
                      style="width: 100%;"
                      @click="verify"
                      :disabled="
                        userNationalCode == '' ||
                          userPhone == '' ||
                          userBirthdate == '' ||
                          userPhone.length != 12
                      "
                      type="button"
                    >
                      استعلام
                    </button>
                  </div>
                  <div
                    style="width: 100%; max-width: 300px;"
                    v-if="shahkarVerify && realInquiryVerify"
                  >
                    <button
                      class="btn btn-success w-full"
                      style="width: 100%;"
                      @click="registerNewUser"
                      :disabled="
                        !realInquiryVerify ||
                          !userFirstName ||
                          !userLastName ||
                          (customerType == 2 && !companyName) ||
                          userNationalCode == '' ||
                          userPhone == '' ||
                          userBirthdate == '' ||
                          userPhone.length != 12
                      "
                      type="button"
                    >
                      {{ customerType == 2 ? "ایجاد مشتری حقوقی" : "ایجاد مشتری جدید" }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="row mt-4 col-12 mx-0 px-0"
            v-if="
              Object.keys(customerDetails).length ||
                Object.keys(legalCustomerDetails).length
            "
          >
            <div class="col-9">
              <div class="card">
                <div class="card-header-custom">
                  <h5 class="mb-2">
                    <i class="fas fa-user-circle"></i>اطلاعات مشتری
                  </h5>
                </div>
                <div class="card-body">
                  <div v-if="existingCustomerOnly" class="mb-3 text-muted">
                    این مشتری از قبل در شعبه ثبت شده است. اطلاعات واردشده در این فرم جایگزین اطلاعات ثبت‌شدهٔ او نشده‌اند.
                    شناسه مشتری: {{ customerId }}
                  </div>
                  <div class="row" v-else-if="customerType == 1">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>نام:</strong> {{ customerDetails.firstName }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>نام خانوادگی :</strong>
                        {{ customerDetails.lastName }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>شماره همراه :</strong>
                        {{ customerDetails.mobile }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>کد ملی :</strong>
                        {{ customerDetails.nationalCode }}
                      </div>
                    </div>
                  </div>
                  <div class="row" v-else-if="customerType == 2">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>نام فارسی :</strong>
                        {{
                          legalCustomerDetails.companyName ||
                            legalCustomerDetails.companyNameFa
                        }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>نام مسئول :</strong>
                        {{ legalCustomerDetails.firstName }}
                        {{ legalCustomerDetails.lastName }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>شماره موبایل مسئول :</strong>
                        {{ legalCustomerDetails.mobile }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="mb-3">
                        <strong>شناسه ملی :</strong>
                        {{ legalCustomerDetails.nationalId }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="card">
                <div class="card-header-custom">
                  <h5 class="mb-2">
                    <i class="fas fa-user-circle"></i>اطلاعات حساب بانکی
                  </h5>
                </div>
                <div class="card-body">
                  <div class="row" v-if="customerType == 1">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <strong>شماره حساب :</strong>
                        <code class="bg-white p-2 rounded text-center"
                          >129-813-986404-1</code
                        >
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="mb-3">
                        <strong>شماره شبا :</strong>
                        <code class="bg-white p-2 rounded text-center"
                          >IR280690012981300986404001</code
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        class="row mt-3"
        v-if="canCreateOrder"
      >
        <div class="col-md-9">
          <nav class="nav nav-tabs mb-3">
            <a
              class="nav-link ml-1 active"
              data-toggle="tab"
              @click="setCurrentTab('fizical-card')"
              href="#fizical-card"
              >کارت هدیه فیزیکی آماده</a
            >
            <a
              class="nav-link"
              data-toggle="tab"
              @click="setCurrentTab('fizical-fizical-card')"
              href="#fizical-fizical-card"
              >کارت هدیه فیزیکی دلخواه</a
            >
          </nav>
          <div class="tab-content">
            <div class="tab-pane active show" id="fizical-card">
              <FizicalCard
                v-if="currentTab == 'fizical-card'"
                :addToCard="addToCard"
                :depositsList="depositsList"
              />
            </div>
            <div class="tab-pane" id="fizical-fizical-card">
              <CustomCard
                v-if="currentTab == 'fizical-fizical-card'"
                :addToCard="addToCard"
                :depositsList="depositsList"
              />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card custom-card card-body tx-white-8 bg-gray-800">
            <h6>سبد خرید</h6>
            <hr class="mb-4 mt-2" />
            <p v-if="!basket.length" class="text-center mb-0">
              سبد خرید خالی است
            </p>
            <div v-else>
              <div
                class="row mb-3"
                v-for="(card, index) in basket"
                :key="index"
              >
                <div class="col-md-4 pl-0">
                  <img
                    :src="
                      !card.imageUrl.includes('base64')
                        ? 'https://cardapi.sabinarya.com' + card.imageUrl
                        : card.imageUrl
                    "
                    class="w-100"
                  />
                </div>
                <div class="col-md-5">
                  <p class="mb-1">{{ card.title }}</p>
                  <p class="mb-1">تعداد: {{ card.itemsCount }}</p>
                  <p class="mb-1">
                    مبلغ شارژ:
                    {{
                      card.deposit
                        ? new Intl.NumberFormat("en-IR", {
                            maximumSignificantDigits: 20,
                          }).format(card.deposit)
                        : 0
                    }}
                  </p>
                </div>
                <div class="col-md-3">
                  <button
                    class="btn ripple btn-danger btn-icon float-left"
                    @click="removeCard(index)"
                  >
                    <i class="fe fe-minus"></i>
                  </button>
                </div>
              </div>
              <hr class="mt-2 mb-4" />
              <!-- <p>مجموع قیمت جسم کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(cardsPrice) }} ریال</p> -->
              <p>
                مجموع قیمت شارژ کارت ها :
                {{
                  new Intl.NumberFormat("en-IR", {
                    maximumSignificantDigits: 20,
                  }).format(chargesPrice)
                }}
                ریال
              </p>
              <button
                class="btn btn-success btn-block"
                v-if="chargesPrice == 0 && false"
                @click="submit"
              >
                تایید و ثبت سفارش
              </button>
            </div>
          </div>

          <div
            class="card custom-card card-body tx-white-8 bg-gray-900"
            v-if="basket.length > 0"
          >
            <h6>ثبت اطلاعات</h6>
            <hr class="mb-4 mt-2" />
            <div class="row mt-3">
              <div class="col-12" v-if="chargesPrice">
                <div class="form-group">
                  <label>شناسه پرداخت</label>
                  <input
                    type="tel"
                    class="form-control ltr-input"
                    v-model="paymentIdentifier"
                    maxlength="30"
                  />
                </div>
              </div>
              <div class="col-12" v-if="chargesPrice">
                <div class="form-group">
                  <label>شماره پیگیری</label>
                  <input
                    type="text"
                    inputmode="numeric"
                    class="form-control ltr-input"
                    v-model="rrn"
                    @input="onlyNumbers"
                  />
                </div>
              </div>
              <div class="col-12" v-if="chargesPrice">
                <div class="form-group">
                  <label>تصویر فیش واریزی</label>
                  <div class="input-group file-browser">
                    <input
                      id="file-input"
                      type="text"
                      class="form-control border-left-0 browse-file"
                      placeholder="انتخاب کنید"
                      readonly=""
                    />
                    <label class="input-group-btn">
                      <span class="btn btn-primary">
                        انتخاب
                        <input
                          type="file"
                          style="display: none;"
                          accept="image/jpeg"
                          @change="setFile"
                        />
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <button
              class="btn btn-success btn-block mt-4"
              @click="submit"
              :disabled="!paymentIsValid"
            >
              تایید و ثبت سفارش
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.verification-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  gap: 4px;
  margin-top: 1.6rem;
}
.status-item {
  font-size: 0.9rem;
  white-space: nowrap;
}
.card-header-custom {
  background: linear-gradient(135deg, #1e2a5e 0%, #14203e 100%);
  color: white;
  font-weight: 600;
  border-radius: 1.25rem 1.25rem 0 0 !important;
  padding: 0.9rem 1.25rem;
  font-size: 0.95rem;
}
.card-header-custom i {
  margin-left: 8px;
  font-size: 1.1rem;
  background: linear-gradient(135deg, #ffd966, #ffb347);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.status-item i {
  margin-left: 6px;
  font-size: 1rem;
}
</style>

<script>
import FizicalCard from "./Cards/FizicalCard";
import CustomCard from "./Cards/CustomCard";
import {
  buildBranchOrderPayload,
  buildCustomerFindPayload,
  buildCustomerRegistrationPayload,
  canCreateBranchOrder,
  calculateChargeTotal,
  formatBranchOptionLabel,
  getBranchCustomerFindOutcome,
  getBranchErrorMessage,
  getBranchRegistrationOutcome,
  hasRequiredPaymentData,
  isManagerRole,
  requiresCustomerForOrder,
} from "@/utils/branchOrderContract";
export default {
  name: "Create",
  components: { FizicalCard, CustomCard },
  data() {
    return {
      orderTarget: "branch",
      customerType: 1,
      nationalCode: "",
      maxLength: 10,
      customerDetails: {},
      legalCustomerDetails: {},
      customerId: 0,
      existingCustomerOnly: false,
      branches: [],
      branchCode: "",
      basket: [],
      currentTab: "fizical-card",
      discount: 0,
      depositsList: [],
      cardsPrice: 0,
      chargesPrice: 0,
      totalPrice: 0,
      displayedTotalPrice: 0,
      showLoading: false,
      paymentIdentifier: "",
      registerUser: false,
      rrn: "",
      file: "",
      companyName: "",
      registerNumber: "",
      userFirstName: "",
      userLastName: "",
      userNationalCode: "",
      userPhone: "",
      userBirthdate: "",
      justCustomCard: false,
      shahkarVerify: false,
      realInquiryVerify: false,
      triedVerify: false,
      customerRequestId: 0,
      verifyingCustomer: false,
    };
  },
  computed: {
    isManager() {
      return isManagerRole(this.$store.state.role);
    },
    isBranchUser() {
      return this.$store.state.role == "branches";
    },
    requiresCustomer() {
      return requiresCustomerForOrder(
        this.$store.state.role,
        this.orderTarget,
      );
    },
    canCreateOrder() {
      return canCreateBranchOrder({
        role: this.$store.state.role,
        branchCode: this.branchCode,
        orderTarget: this.orderTarget,
        customerId: this.customerId,
      });
    },
    paymentIsValid() {
      return (
        this.canCreateOrder &&
        this.basket.length > 0 &&
        hasRequiredPaymentData(this.chargesPrice, {
          base64Receipt: this.file,
          rrn: this.rrn,
          paymentIdentifier: this.paymentIdentifier,
        })
      );
    },
  },
  watch: {
    branchCode: function(value, oldValue) {
      if (value !== oldValue) this.resetCustomerSelection();
    },
    userNationalCode: function(value, oldValue) {
      if (value !== oldValue) this.invalidateVerification();
    },
    userPhone: function(value, oldValue) {
      if (value !== oldValue) this.invalidateVerification();
    },
    userBirthdate: function(value, oldValue) {
      if (value !== oldValue) this.invalidateVerification();
    },
    discount: function(value) {
      let discount = parseInt(value.toString().replace(/,/g, ""));
      if (!this.discount) this.discount = 0;
      else if (this.totalPrice > discount)
        this.displayedTotalPrice = this.totalPrice - discount;
      else {
        this.discount = new Intl.NumberFormat("en-IR", {
          maximumSignificantDigits: 20,
        }).format(this.totalPrice);
        this.displayedTotalPrice = 0;
      }
    },
  },
  methods: {
    formatBranchOptionLabel,
    getData() {
      if (this.isManager) {
        this.$api.get("Branches/List")
          .then(({ data }) => {
            if (data.status) {
              this.branches = Array.isArray(data.result)
                ? data.result
                : (data.result && data.result.list) || [];
            } else if (!data.showError) this.showServerErrors(data);
          })
          .catch((error) => {
            this.showServerErrors((error.response && error.response.data) || {});
          });
      }
      this.$api.get("Cards/Deposits").then(({ data }) => {
        this.showLoading = false;
        if (data.status) {
          let deposits = data.result;
          deposits.sort((a, b) => {
            return a.depositValue - b.depositValue;
          });
          this.depositsList = deposits;
        }
      });
    },
    resetCustomerSelection(clearIdentifier = true) {
      this.customerRequestId += 1;
      this.showLoading = false;
      this.verifyingCustomer = false;
      this.registerUser = false;
      this.customerId = 0;
      this.existingCustomerOnly = false;
      this.customerDetails = {};
      this.legalCustomerDetails = {};
      this.basket = [];
      this.cardsPrice = 0;
      this.chargesPrice = 0;
      this.totalPrice = 0;
      this.displayedTotalPrice = 0;
      this.rrn = "";
      this.paymentIdentifier = "";
      this.file = "";
      const fileInput = document.getElementById("file-input");
      if (fileInput) {
        fileInput.value = "";
        fileInput.setAttribute("placeholder", "انتخاب کنید");
      }
      this.companyName = "";
      this.registerNumber = "";
      this.shahkarVerify = false;
      this.realInquiryVerify = false;
      this.triedVerify = false;
      this.userFirstName = "";
      this.userLastName = "";
      this.userNationalCode = "";
      this.userPhone = "";
      this.userBirthdate = "";
      if (clearIdentifier) this.nationalCode = "";
    },
    showServerErrors(responseData) {
      this.$swal({
        icon: "error",
        title: "خطا",
        text: getBranchErrorMessage(responseData),
        confirmButtonText: "متوجه شدم",
      });
    },
    onIdentifierInput() {
      if (this.customerId || this.registerUser || this.showLoading) {
        this.resetCustomerSelection(false);
      }
    },
    invalidateVerification() {
      if (!this.verifyingCustomer && !this.shahkarVerify && !this.realInquiryVerify) return;
      this.customerRequestId += 1;
      this.showLoading = false;
      this.verifyingCustomer = false;
      this.shahkarVerify = false;
      this.realInquiryVerify = false;
      this.triedVerify = false;
      this.userFirstName = "";
      this.userLastName = "";
    },
    changeOrderTarget() {
      this.resetCustomerSelection();
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
      this.rrn = "";
      this.paymentIdentifier = "";
    },
    onlyNumbers(event) {
      // حذف هر کاراکتری غیر از رقم
      let numericValue = event.target.value.replace(/[^0-9]/g, "");
      // به‌روزرسانی متغیر
      this.rrn = numericValue;
    },
    async verify() {
      const requestId = ++this.customerRequestId;
      try {
        this.showLoading = true;
        this.verifyingCustomer = true;

        // Reset flags at the beginning
        this.shahkarVerify = false;
        this.realInquiryVerify = false;
        const verifyPayload = {
          nationalCode: this.userNationalCode,
          mobileNumber: this.userPhone.replace("-", ""),
          birthDate: this.userBirthdate.replaceAll("/", ""),
        };

        const shahkarRes = await this.$api.post(
          "Customer/Shahkar",
          verifyPayload,
        );
        if (requestId !== this.customerRequestId) return;
        if (shahkarRes.data.result && shahkarRes.data.status) {
          this.shahkarVerify = true;
        } else {
          if (!shahkarRes.data.showError) {
            if (shahkarRes.data.errors) this.showServerErrors(shahkarRes.data);
            else this.$swal({ title: "ناموفق", icon: "error", text: "استعلام شاهکار ناموفق بود" });
          }
          return;
        }

        const realInquiryRes = await this.$api.post(
          "Customer/RealInquiry",
          verifyPayload,
        );
        if (requestId !== this.customerRequestId) return;
        if (realInquiryRes.data.status) {
          this.realInquiryVerify = true;
          this.userFirstName = realInquiryRes.data.result.firstName;
          this.userLastName = realInquiryRes.data.result.lastName;
        } else if (!realInquiryRes.data.showError && realInquiryRes.data.errors) {
          this.showServerErrors(realInquiryRes.data);
        }
      } catch (error) {
        if (requestId === this.customerRequestId) {
          this.showServerErrors((error.response && error.response.data) || {});
        }
      } finally {
        if (requestId === this.customerRequestId) {
          this.showLoading = false;
          this.verifyingCustomer = false;
          this.triedVerify = true;
        }
      }
    },
    async registerNewUser() {
      const requestId = ++this.customerRequestId;
      this.showLoading = true;
      // Reset flags at the beginning

      try {
        if (this.shahkarVerify && this.realInquiryVerify) {
          const postedData = buildCustomerRegistrationPayload({
            role: this.$store.state.role,
            branchCode: this.branchCode,
            customerType: this.customerType,
            nationalCode: this.userNationalCode,
            mobile: this.userPhone.replace("-", ""),
            birthDate: this.userBirthdate.replaceAll("/", ""),
            companyName: this.companyName,
            nationalId: this.nationalCode,
            registerNumber: this.registerNumber,
          });

          const registerRes = await this.$api.post(
            "Branches/RegisterUser",
            postedData,
          );
          if (requestId !== this.customerRequestId) return;
          const registrationOutcome = getBranchRegistrationOutcome(
            registerRes.data,
          );
          if (registrationOutcome.kind === "selected") {
            this.customerId = registrationOutcome.customerId;
            this.existingCustomerOnly = registrationOutcome.alreadyExists;
            const registeredCustomer = registrationOutcome.alreadyExists
              ? { customerId: this.customerId }
              : {
                  customerId: this.customerId,
                  firstName: this.userFirstName,
                  lastName: this.userLastName,
                  nationalCode: this.userNationalCode,
                  mobile: this.userPhone.replace("-", ""),
                };
            if (this.customerType == 2) {
              this.legalCustomerDetails = registrationOutcome.alreadyExists
                ? registeredCustomer
                : {
                    ...registeredCustomer,
                    companyName: this.companyName,
                    nationalId: this.nationalCode,
                    registerNumber: this.registerNumber,
                  };
              this.customerDetails = {};
            } else {
              this.customerDetails = registeredCustomer;
              this.legalCustomerDetails = {};
              this.nationalCode = this.userNationalCode;
            }
            this.registerUser = false;
            await this.$swal({
              title: "تبریک",
              icon: "success",
              text: registrationOutcome.alreadyExists
                ? "مشتری از قبل در این شعبه ثبت شده بود؛ همان شناسهٔ موجود انتخاب شد."
                : "مشتری جدید با موفقیت ایجاد شد",
              confirmButtonText: "متوجه شدم",
            });
            this.userFirstName = "";
            this.userLastName = "";
            this.userNationalCode = "";
            this.userPhone = "";
            this.userBirthdate = "";
            this.companyName = "";
            this.registerNumber = "";
          } else if (!registerRes.data.showError) {
            this.showServerErrors(registerRes.data);
          }
        }
      } catch (error) {
        if (requestId !== this.customerRequestId) return;
        this.showServerErrors((error.response && error.response.data) || {});
      } finally {
        if (requestId === this.customerRequestId) this.showLoading = false;
      }
    },
    addToCard(
      themeId,
      title,
      cardType,
      itemsCount,
      price,
      imageUrl,
      showAmountOnCard,
      depositId,
      optionalCredit = null,
      metaData = [],
      imageMediaId = null,
    ) {
      if (this.basket.length > 0) {
        // let existsDesign = this.basket[0].themeId == themeId;
        if (
          // !existsDesign ||
          themeId == 0
        ) {
          this.$swal({
            icon: "error",
            title: "خطا",
            text: "شما نمی توانید بیشتر از یک طرح به سبد خرید خود اضافه کنید",
            confirmButtonText: "متوجه شدم",
          });
          return false;
        }
      }
      depositId = parseInt(depositId);
      let deposit = 0;
      const isCustomDeposit = depositId == 61 || depositId == 102;
      if (isCustomDeposit && optionalCredit) {
        optionalCredit = parseInt(String(optionalCredit).replace(/,/g, ""));
        deposit = optionalCredit;
      } else {
        let getDeposit = this.depositsList.filter(
          (deposit) => deposit.depositId == depositId,
        )[0];
        if (getDeposit && depositId != 41) deposit = getDeposit.depositValue;
        else deposit = 0;
      }
      if (cardType == 1 || cardType == 2) {
        let hasInBasket = this.basket.filter(
            (item) =>
            item.themeId == themeId &&
            item.cardType == cardType &&
            item.depositId == depositId &&
            item.showAmountOnCard === Boolean(showAmountOnCard) &&
            (item.optionalCredit == optionalCredit || item.optionalCredit == 0),
        );
        if (hasInBasket.length) {
          let findIndex = this.basket.findIndex(
            (item) => item == hasInBasket[0],
          );
          this.basket[findIndex].itemsCount =
            parseInt(this.basket[findIndex].itemsCount) + parseInt(itemsCount);
        } else
          this.basket.push({
            themeId,
            title:
              cardType == 1
                ? title
                : cardType == 2
                ? title + " مجازی"
                : cardType == 3
                ? "کارت هدیه مجازی"
                : "کارت هدیه دلخواه",
            imageUrl,
            showAmountOnCard: showAmountOnCard ? true : false,
            itemsCount: parseInt(itemsCount),
            price,
            cardType,
            depositId,
            optionalCredit: isCustomDeposit ? optionalCredit : 0,
            deposit,
            mediaId: imageMediaId,
            metaDatas: metaData,
          });
      } else
        this.basket.push({
          themeId,
          title:
            cardType == 1
              ? title
              : cardType == 2
              ? title + " مجازی"
              : cardType == 3
              ? "کارت هدیه دلخواه"
              : "کارت هدیه مجازی",
          imageUrl,
          showAmountOnCard: showAmountOnCard ? true : false,
          itemsCount: parseInt(itemsCount),
          price,
          cardType,
          depositId,
          optionalCredit: isCustomDeposit ? optionalCredit : 0,
          deposit,
          mediaId: imageMediaId,
          metaDatas: metaData,
        });
      this.justCustomCard = true;
      this.basket.map((item) => {
        if (item.cardType != 3) this.justCustomCard = false;
      });
      this.calcTotalPrice();
    },
    calcTotalPrice() {
      let depositAmount = 0;
      this.chargesPrice = 0;
      this.cardsPrice = 0;
      let getDeposit;
      this.basket.map((item) => {
        depositAmount = 0;
        if (item.depositId && item.depositId != 41) {
          if (item.depositId == 61 || item.depositId == 102)
            depositAmount += parseInt(item.optionalCredit) * item.itemsCount;
          else {
            getDeposit = this.depositsList.filter(
              (deposit) => deposit.depositId == item.depositId,
            )[0];
            depositAmount +=
              parseInt(getDeposit.depositValue) * item.itemsCount;
          }
        }
        this.chargesPrice += depositAmount;
      });
      this.totalPrice = calculateChargeTotal(this.basket);
      let discount = parseInt(this.discount.toString().replace(/,/g, ""));
      if (this.totalPrice > discount)
        this.displayedTotalPrice = this.totalPrice - discount;
      else this.displayedTotalPrice = 0;
    },
    searchCustomer() {
      if (!this.requiresCustomer || (this.isManager && !this.branchCode)) return;
      this.resetCustomerSelection(false);
      const requestId = ++this.customerRequestId;
      const postedData = buildCustomerFindPayload({
        role: this.$store.state.role,
        branchCode: this.branchCode,
        customerType: this.customerType,
        identifier: this.nationalCode,
      });
      this.showLoading = true;
      this.$api
        .post("User/Find", postedData)
        .then(({ data }) => {
          if (requestId !== this.customerRequestId) return;
          const findOutcome = getBranchCustomerFindOutcome(data);
          if (findOutcome.kind === "found") {
            if (this.customerType == 1) {
              this.customerDetails = findOutcome.customer;
            } else {
              this.legalCustomerDetails = findOutcome.customer;
            }
            this.setCurrentTab("fizical-card");
            this.customerId = findOutcome.customerId;
          } else if (findOutcome.kind === "notFound") {
            this.registerUser = true;
            if (this.customerType == 1) {
              this.userNationalCode = this.nationalCode;
            }
          } else if (!data.showError) {
            this.showServerErrors(data);
          }
        })
        .catch((error) => {
          if (requestId === this.customerRequestId) {
            this.showServerErrors((error.response && error.response.data) || {});
          }
        })
        .finally(() => {
          if (requestId === this.customerRequestId) this.showLoading = false;
        });
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async setFile(e) {
      const requestId = this.customerRequestId;
      const file = e.target.files[0];
      if (!file) {
        this.file = "";
        return;
      }
      const finalFile = await this.toBase64(file);
      if (requestId !== this.customerRequestId) return;
      this.file = finalFile;
      const fileInput = document.getElementById("file-input");
      if (fileInput) fileInput.setAttribute("placeholder", file.name);
    },
    removeCard(itemIndex) {
      let basket = this.basket.filter((item, index) => index != itemIndex);
      this.basket = basket;
      this.calcTotalPrice();
    },
    discountNumberFormat() {
      let value = this.discount.toString().replace(/,/g, "");
      value = new Intl.NumberFormat("en-IR", {
        maximumSignificantDigits: 20,
      }).format(value);
      if (value == "NaN") value = "";
      this.discount = value;
    },
    changeCustomerType() {
      this.resetCustomerSelection();
      this.maxLength = this.customerType == 1 ? 10 : 11;
    },
    submit() {
      if (!this.paymentIsValid) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "برای سفارش دارای مبلغ، تصویر فیش و یکی از شماره‌های پیگیری یا شناسه پرداخت الزامی است.",
          confirmButtonText: "متوجه شدم",
        });
        return;
      }
      this.$swal({
        icon: "warning",
        title: "توجه !",
        text: "آیا از ثبت سفارش اطمینان دارید ؟",
        confirmButtonText: "ثبت سفارش",
        showCancelButton: true,
        cancelButtonText: "لغو",
      }).then((result) => {
        if (result.isConfirmed) {
          let postedData;
          try {
            postedData = buildBranchOrderPayload({
              role: this.$store.state.role,
              branchCode: this.branchCode,
              orderTarget: this.orderTarget,
              customerId: this.customerId,
              basket: this.basket,
              rrn: this.rrn,
              paymentIdentifier: this.paymentIdentifier,
              base64Receipt: this.file,
            });
          } catch (error) {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "اطلاعات سفارش معتبر نیست. لطفاً شعبه، مشتری، کارت‌ها و اطلاعات پرداخت را دوباره بررسی کنید.",
              confirmButtonText: "متوجه شدم",
            });
            return;
          }
          this.showLoading = true;
          this.$api
            .post("Branches/Orders", postedData)
            .then(({ data }) => {
              if (data.status) {
                this.$swal({
                  title: "تبریک",
                  icon: "success",
                  text: "ثبت سفارش شما با موفقیت انجام شد",
                  confirmButtonText: "متوجه شدم",
                }).then(() => {
                  this.$router.push({ path: "/?today=true" });
                });
              } else if (!data.showError) {
                this.showServerErrors(data);
              }
            })
            .catch((error) => {
              this.showServerErrors((error.response && error.response.data) || {});
            })
            .finally(() => {
              this.showLoading = false;
            });
        }
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
